import { render } from "./BootstrapModal.vue?vue&type=template&id=bcc3f11a"
import script from "./BootstrapModal.vue?vue&type=script&lang=js"
export * from "./BootstrapModal.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__